import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Upload, Globe, Instagram, Twitter, Music, MapPin, AlertCircle, CheckCircle2, ExternalLink, FileText, Image as ImageIcon } from 'lucide-react';
export function ArtistProfilePage() {
  const [activeTab, setActiveTab] = useState('Overview');
  const tabs = ['Overview', 'Profile', 'Policy', 'Lineup', 'Assets', 'Booking Page', 'History'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-1677">
      {/* Header */}
      <div className="mb-6 flex justify-between items-end" data-id="element-1678">
        <div className="flex items-center gap-6" data-id="element-1679">
          <div className="w-24 h-24 rounded-full bg-surface border-2 border-border flex items-center justify-center text-3xl font-bold text-textMuted overflow-hidden" data-id="element-1680">
            <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&q=80&w=256&h=256" alt="Artist" className="w-full h-full object-cover opacity-80" data-id="element-1681" />
          </div>
          <div data-id="element-1682">
            <h2 className="text-3xl font-bold mb-2" data-id="element-1683">The Wildwoods</h2>
            <div className="flex items-center gap-4 text-sm" data-id="element-1684">
              <span className="flex items-center gap-1.5 text-textMuted" data-id="element-1685">
                <MapPin className="w-4 h-4" data-id="element-1686" /> Burlington, VT
              </span>
              <div className="flex gap-2" data-id="element-1687">
                <span className="px-2 py-0.5 bg-surface border border-border rounded text-xs" data-id="element-1688">
                  Folk
                </span>
                <span className="px-2 py-0.5 bg-surface border border-border rounded text-xs" data-id="element-1689">
                  Americana
                </span>
                <span className="px-2 py-0.5 bg-surface border border-border rounded text-xs" data-id="element-1690">
                  Indie
                </span>
              </div>
            </div>
          </div>
        </div>
        <button className="px-4 py-2 bg-primary text-background text-sm font-medium rounded-lg hover:bg-primaryHover transition-colors" data-id="element-1691">
          Edit Profile
        </button>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b border-border mb-6 overflow-x-auto" data-id="element-1692">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-1693">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="pb-12" data-id="element-1694">
        {activeTab === 'Overview' && <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1695">
            <div className="md:col-span-2 space-y-6" data-id="element-1696">
              {/* Stats Row */}
              <div className="grid grid-cols-3 gap-4" data-id="element-1697">
                <div className="bg-surface border border-border rounded-xl p-5" data-id="element-1698">
                  <div className="text-sm text-textMuted mb-1" data-id="element-1699">
                    Active Campaigns
                  </div>
                  <div className="text-2xl font-bold" data-id="element-1700">3</div>
                </div>
                <div className="bg-surface border border-border rounded-xl p-5" data-id="element-1701">
                  <div className="text-sm text-textMuted mb-1" data-id="element-1702">
                    Shows This Year
                  </div>
                  <div className="text-2xl font-bold" data-id="element-1703">12</div>
                </div>
                <div className="bg-surface border border-border rounded-xl p-5" data-id="element-1704">
                  <div className="text-sm text-textMuted mb-1" data-id="element-1705">Revenue YTD</div>
                  <div className="text-2xl font-bold text-primary" data-id="element-1706">$22,400</div>
                </div>
              </div>

              {/* Upcoming Shows */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1707">
                <div className="flex justify-between items-center mb-4" data-id="element-1708">
                  <h3 className="text-lg font-semibold" data-id="element-1709">Upcoming Shows</h3>
                  <button className="text-sm text-primary hover:underline" data-id="element-1710">
                    View All
                  </button>
                </div>
                <div className="space-y-3" data-id="element-1711">
                  {[{
                date: 'Jun 12',
                venue: 'The Empty Bottle',
                city: 'Chicago, IL',
                status: 'Advancing'
              }, {
                date: 'Jun 14',
                venue: 'Beachland Tavern',
                city: 'Cleveland, OH',
                status: 'Needs Advance'
              }, {
                date: 'Jun 18',
                venue: 'Higher Ground',
                city: 'Burlington, VT',
                status: 'Confirmed'
              }].map((show, i) => <div key={i} className="flex items-center justify-between p-3 bg-background border border-border rounded-lg" data-id="element-1712">
                      <div className="flex items-center gap-4" data-id="element-1713">
                        <div className="text-center shrink-0 w-12" data-id="element-1714">
                          <div className="text-xs text-textMuted" data-id="element-1715">Jun</div>
                          <div className="text-lg font-bold" data-id="element-1716">
                            {show.date.split(' ')[1]}
                          </div>
                        </div>
                        <div data-id="element-1717">
                          <div className="font-medium text-sm" data-id="element-1718">
                            {show.venue}
                          </div>
                          <div className="text-xs text-textMuted" data-id="element-1719">
                            {show.city}
                          </div>
                        </div>
                      </div>
                      <span className={`px-2 py-1 text-xs rounded font-medium ${show.status === 'Confirmed' ? 'bg-green-500/10 text-green-500' : 'bg-primary/10 text-primary'}`} data-id="element-1720">
                        {show.status}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>

            <div className="space-y-6" data-id="element-1721">
              {/* Readiness Score */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1722">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-1723">
                  Booking Readiness
                </h3>
                <div className="flex items-center gap-4 mb-6" data-id="element-1724">
                  <div className="w-16 h-16 rounded-full border-4 border-primary flex items-center justify-center text-xl font-bold text-primary" data-id="element-1725">
                    82
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-1726">
                    Your profile is looking good, but missing a few key items.
                  </div>
                </div>
                <div className="space-y-3" data-id="element-1727">
                  <div className="flex items-center gap-2 text-sm" data-id="element-1728">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-1729" /> Bio &
                    Photos
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-1730">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-1731" /> Booking
                    Policy
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-1732">
                    <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-1733" /> Stage
                    Plot
                  </div>
                  <div className="flex items-center gap-2 text-sm text-amber-500" data-id="element-1734">
                    <AlertCircle className="w-4 h-4" data-id="element-1735" /> Missing W-9 Form
                  </div>
                </div>
              </div>

              {/* Top Markets */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1736">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-1737">
                  Top Markets
                </h3>
                <div className="space-y-3" data-id="element-1738">
                  <div className="flex justify-between items-center text-sm" data-id="element-1739">
                    <span data-id="element-1740">Chicago, IL</span>
                    <span className="text-textMuted" data-id="element-1741">8 shows</span>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-1742">
                    <span data-id="element-1743">Burlington, VT</span>
                    <span className="text-textMuted" data-id="element-1744">6 shows</span>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-1745">
                    <span data-id="element-1746">Cleveland, OH</span>
                    <span className="text-textMuted" data-id="element-1747">4 shows</span>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-1748">
                    <span data-id="element-1749">Cambridge, MA</span>
                    <span className="text-textMuted" data-id="element-1750">3 shows</span>
                  </div>
                </div>
              </div>

              {/* Lineup Risk */}
              <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-5" data-id="element-1751">
                <div className="flex items-start gap-3" data-id="element-1752">
                  <AlertCircle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-1753" />
                  <div data-id="element-1754">
                    <h4 className="text-sm font-medium text-amber-500 mb-1" data-id="element-1755">
                      Lineup Risk
                    </h4>
                    <p className="text-xs text-amber-500/80" data-id="element-1756">
                      1 conflict detected this month (Tom Rivera on Jun 12).
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Profile' && <div className="max-w-3xl" data-id="element-1757">
            <div className="bg-surface border border-border rounded-xl p-8 space-y-6" data-id="element-1758">
              <div data-id="element-1759">
                <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1760">
                  Artist / Band Name
                </label>
                <input type="text" defaultValue="The Wildwoods" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1761" />
              </div>

              <div data-id="element-1762">
                <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1763">
                  Genres (comma separated)
                </label>
                <input type="text" defaultValue="Folk, Americana, Indie" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1764" />
              </div>

              <div data-id="element-1765">
                <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1766">
                  Bio
                </label>
                <textarea rows={4} defaultValue="The Wildwoods are an indie-folk trio based in Burlington, Vermont. Known for their tight harmonies and energetic live shows..." className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-1767"></textarea>
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-1768">
                <div data-id="element-1769">
                  <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1770">
                    Home Base
                  </label>
                  <input type="text" defaultValue="Burlington, VT" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1771" />
                </div>
                <div data-id="element-1772">
                  <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1773">
                    Website
                  </label>
                  <div className="relative" data-id="element-1774">
                    <Globe className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-1775" />
                    <input type="text" defaultValue="thewildwoodsband.com" className="w-full pl-9 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1776" />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4" data-id="element-1777">
                <div data-id="element-1778">
                  <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1779">
                    Spotify
                  </label>
                  <div className="relative" data-id="element-1780">
                    <Music className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-1781" />
                    <input type="text" placeholder="URL" className="w-full pl-9 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1782" />
                  </div>
                </div>
                <div data-id="element-1783">
                  <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1784">
                    Instagram
                  </label>
                  <div className="relative" data-id="element-1785">
                    <Instagram className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-1786" />
                    <input type="text" placeholder="@handle" className="w-full pl-9 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1787" />
                  </div>
                </div>
                <div data-id="element-1788">
                  <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1789">
                    Twitter
                  </label>
                  <div className="relative" data-id="element-1790">
                    <Twitter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-1791" />
                    <input type="text" placeholder="@handle" className="w-full pl-9 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1792" />
                  </div>
                </div>
              </div>

              <div className="pt-4" data-id="element-1793">
                <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1794">
                  Press Photo
                </label>
                <div className="border-2 border-dashed border-border rounded-xl p-8 text-center hover:border-primary/50 transition-colors cursor-pointer bg-background" data-id="element-1795">
                  <Upload className="w-8 h-8 text-textMuted mx-auto mb-3" data-id="element-1796" />
                  <p className="text-sm font-medium mb-1" data-id="element-1797">
                    Click to upload or drag and drop
                  </p>
                  <p className="text-xs text-textMuted" data-id="element-1798">PNG, JPG up to 10MB</p>
                </div>
              </div>

              <div className="pt-6 border-t border-border flex justify-end" data-id="element-1799">
                <button className="px-6 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium text-sm" data-id="element-1800">
                  Save Profile
                </button>
              </div>
            </div>
          </div>}

        {activeTab === 'Policy' && <div className="max-w-3xl" data-id="element-1801">
            <div className="bg-surface border border-border rounded-xl p-8 space-y-8" data-id="element-1802">
              <div data-id="element-1803">
                <h3 className="text-lg font-semibold mb-4" data-id="element-1804">Financial Policy</h3>
                <div className="grid grid-cols-2 gap-6" data-id="element-1805">
                  <div data-id="element-1806">
                    <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1807">
                      Target Fee
                    </label>
                    <div className="relative" data-id="element-1808">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-textMuted" data-id="element-1809">
                        $
                      </span>
                      <input type="number" defaultValue="2000" className="w-full pl-7 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1810" />
                    </div>
                  </div>
                  <div data-id="element-1811">
                    <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1812">
                      Minimum Acceptable Fee
                    </label>
                    <div className="relative" data-id="element-1813">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-textMuted" data-id="element-1814">
                        $
                      </span>
                      <input type="number" defaultValue="1500" className="w-full pl-7 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1815" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-border" data-id="element-1816">
                <h3 className="text-lg font-semibold mb-4" data-id="element-1817">
                  Logistics & Rider
                </h3>
                <div className="space-y-4" data-id="element-1818">
                  <div data-id="element-1819">
                    <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1820">
                      Lodging Requirement
                    </label>
                    <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1821">
                      <option data-id="element-1822">Require if &gt; 150 miles from home</option>
                      <option data-id="element-1823">Always require</option>
                      <option data-id="element-1824">Never require</option>
                    </select>
                  </div>
                  <div data-id="element-1825">
                    <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1826">
                      Deposit Rules
                    </label>
                    <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1827">
                      <option data-id="element-1828">50% standard</option>
                      <option data-id="element-1829">100% upfront</option>
                      <option data-id="element-1830">No deposit required</option>
                    </select>
                  </div>
                  <div data-id="element-1831">
                    <label className="block text-sm font-medium mb-2 text-textMuted" data-id="element-1832">
                      Standard Rider Notes
                    </label>
                    <textarea rows={3} defaultValue="2 veg meals, 2 standard. 1 case sparkling water. Secure parking for 1 van." className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-1833"></textarea>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-border flex justify-end" data-id="element-1834">
                <button className="px-6 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium text-sm" data-id="element-1835">
                  Save Policies
                </button>
              </div>
            </div>
          </div>}

        {activeTab === 'Lineup' && <div className="max-w-4xl" data-id="element-1836">
            <div className="bg-surface border border-border rounded-xl p-6 mb-6" data-id="element-1837">
              <div className="flex justify-between items-center mb-6" data-id="element-1838">
                <h3 className="text-lg font-semibold" data-id="element-1839">Required Roles</h3>
                <button className="text-sm text-primary hover:underline" data-id="element-1840">
                  Add Role
                </button>
              </div>
              <div className="space-y-3" data-id="element-1841">
                {['Guitar/Vocals', 'Bass', 'Drums', 'Keys'].map((role, i) => <div key={i} className="flex items-center justify-between p-3 bg-background border border-border rounded-lg" data-id="element-1842">
                    <span className="font-medium text-sm" data-id="element-1843">{role}</span>
                    <span className="text-xs text-textMuted bg-surface px-2 py-1 rounded" data-id="element-1844">
                      Required
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1845">
              <h3 className="text-lg font-semibold mb-4" data-id="element-1846">Substitute Rules</h3>
              <p className="text-sm text-textMuted mb-4" data-id="element-1847">
                Define who can fill in if a primary member is unavailable.
              </p>
              <div className="p-4 border border-dashed border-border rounded-lg text-center" data-id="element-1848">
                <p className="text-sm text-textMuted mb-2" data-id="element-1849">
                  No substitutes configured.
                </p>
                <button className="text-sm text-primary hover:underline" data-id="element-1850">
                  Add Substitute
                </button>
              </div>
            </div>
          </div>}

        {activeTab === 'Assets' && <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1851">
            {[{
          name: 'Press Photo 1 (High Res)',
          type: 'Image',
          icon: <ImageIcon className="w-5 h-5 text-green-500" data-id="element-1852" />
        }, {
          name: 'Stage Plot 2026',
          type: 'PDF',
          icon: <FileText className="w-5 h-5 text-blue-500" data-id="element-1853" />
        }, {
          name: 'Standard Rider',
          type: 'PDF',
          icon: <FileText className="w-5 h-5 text-blue-500" data-id="element-1854" />
        }, {
          name: 'W-9 Form',
          type: 'PDF',
          icon: <FileText className="w-5 h-5 text-textMuted" data-id="element-1855" />
        }, {
          name: 'Logo Pack',
          type: 'ZIP',
          icon: <FileText className="w-5 h-5 text-textMuted" data-id="element-1856" />
        }].map((asset, i) => <div key={i} className="bg-surface border border-border rounded-xl p-5 hover:border-primary/50 transition-colors cursor-pointer group flex flex-col" data-id="element-1857">
                <div className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center mb-4" data-id="element-1858">
                  {asset.icon}
                </div>
                <h3 className="font-medium text-sm mb-1 group-hover:text-primary transition-colors" data-id="element-1859">
                  {asset.name}
                </h3>
                <span className="text-xs text-textMuted mt-auto pt-4" data-id="element-1860">
                  {asset.type}
                </span>
              </div>)}
            <div className="bg-background border-2 border-dashed border-border rounded-xl p-5 hover:border-primary/50 transition-colors cursor-pointer flex flex-col items-center justify-center text-center min-h-[160px]" data-id="element-1861">
              <Upload className="w-6 h-6 text-textMuted mb-2" data-id="element-1862" />
              <span className="text-sm font-medium" data-id="element-1863">Upload Asset</span>
            </div>
          </div>}

        {activeTab === 'Booking Page' && <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1864">
            <div className="md:col-span-2" data-id="element-1865">
              <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-1866">
                <div className="bg-background p-4 border-b border-border flex items-center justify-between" data-id="element-1867">
                  <div className="flex items-center gap-2 text-sm text-textMuted" data-id="element-1868">
                    <Globe className="w-4 h-4" data-id="element-1869" /> booker.com/the-wildwoods
                  </div>
                  <button className="text-sm text-primary hover:underline flex items-center gap-1" data-id="element-1870">
                    <ExternalLink className="w-4 h-4" data-id="element-1871" /> View Live
                  </button>
                </div>
                <div className="p-8 bg-[#0A0A0F]" data-id="element-1872">
                  {/* Mock Public Page */}
                  <div className="max-w-xl mx-auto text-center" data-id="element-1873">
                    <div className="w-32 h-32 rounded-full bg-surface border-2 border-border mx-auto mb-6 overflow-hidden" data-id="element-1874">
                      <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?auto=format&fit=crop&q=80&w=256&h=256" alt="Artist" className="w-full h-full object-cover opacity-80" data-id="element-1875" />
                    </div>
                    <h1 className="text-3xl font-bold mb-2" data-id="element-1876">The Wildwoods</h1>
                    <p className="text-textMuted mb-8" data-id="element-1877">
                      Folk / Americana • Burlington, VT
                    </p>

                    <div className="bg-surface border border-border rounded-xl p-6 text-left mb-8" data-id="element-1878">
                      <h3 className="font-semibold mb-4" data-id="element-1879">Booking Inquiry</h3>
                      <div className="space-y-4" data-id="element-1880">
                        <input type="text" placeholder="Your Name" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm" disabled data-id="element-1881" />
                        <input type="text" placeholder="Venue / Event Name" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm" disabled data-id="element-1882" />
                        <input type="date" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm text-textMuted" disabled data-id="element-1883" />
                        <button className="w-full py-2 bg-primary text-background rounded-lg font-medium opacity-50" disabled data-id="element-1884">
                          Send Inquiry
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-6" data-id="element-1885">
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1886">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-1887">
                  Page Settings
                </h3>
                <div className="space-y-4" data-id="element-1888">
                  <label className="flex items-center justify-between cursor-pointer" data-id="element-1889">
                    <span className="text-sm" data-id="element-1890">Publicly Visible</span>
                    <div className="w-10 h-6 bg-primary rounded-full relative" data-id="element-1891">
                      <div className="w-4 h-4 bg-background rounded-full absolute right-1 top-1" data-id="element-1892"></div>
                    </div>
                  </label>
                  <label className="flex items-center justify-between cursor-pointer" data-id="element-1893">
                    <span className="text-sm" data-id="element-1894">Show Fee Range</span>
                    <div className="w-10 h-6 bg-surfaceHover border border-border rounded-full relative" data-id="element-1895">
                      <div className="w-4 h-4 bg-textMuted rounded-full absolute left-1 top-1" data-id="element-1896"></div>
                    </div>
                  </label>
                  <label className="flex items-center justify-between cursor-pointer" data-id="element-1897">
                    <span className="text-sm" data-id="element-1898">Require Budget in Form</span>
                    <div className="w-10 h-6 bg-primary rounded-full relative" data-id="element-1899">
                      <div className="w-4 h-4 bg-background rounded-full absolute right-1 top-1" data-id="element-1900"></div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'History' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-1901">
            <table className="w-full text-sm text-left" data-id="element-1902">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-1903">
                <tr data-id="element-1904">
                  <th className="px-6 py-4 font-medium" data-id="element-1905">Date</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1906">Venue</th>
                  <th className="px-6 py-4 font-medium" data-id="element-1907">City</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-1908">
                    Guarantee
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-1909">
                {[{
              date: 'Mar 15, 2026',
              venue: "Antone's",
              city: 'Austin, TX',
              fee: '$2,000'
            }, {
              date: 'Mar 18, 2026',
              venue: 'Continental Club',
              city: 'Austin, TX',
              fee: '$1,800'
            }, {
              date: 'Mar 20, 2026',
              venue: 'White Oak',
              city: 'Houston, TX',
              fee: '$2,500'
            }, {
              date: 'Feb 10, 2026',
              venue: 'The Basement',
              city: 'Nashville, TN',
              fee: '$1,200'
            }].map((show, i) => <tr key={i} className="hover:bg-surfaceHover transition-colors" data-id="element-1910">
                    <td className="px-6 py-4 text-textMuted" data-id="element-1911">{show.date}</td>
                    <td className="px-6 py-4 font-medium" data-id="element-1912">{show.venue}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-1913">{show.city}</td>
                    <td className="px-6 py-4 text-right font-medium" data-id="element-1914">
                      {show.fee}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </motion.div>;
}